import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastController, ModalController } from '@ionic/angular';
import { TournamentService } from '../../../gamer/services/tournament.service';
import { IPlayer, ITeam, LineUpService, TshirtStyle } from '../../services/lineup-service';
import { Router } from '@angular/router';

@Component({
  selector: 'create-player',
  templateUrl: 'create-player.html',
  styleUrls:['./create-player.scss']
})
export class CreatePlayerComponent {
  activePlan: number = 0;
  activeTeam: number = 0;
  newPlanName: string = "";
  newTeamName: string = "";
  routerState:any;

  constructor(
    public viewCtrl: ModalController,
    private toastCtrl: ToastController,
    private translate: TranslateService,
    private ls: LineUpService,
    private router:Router,
    public gs: TournamentService
  ) {
    const nav = this.router.getCurrentNavigation();
    this.routerState = nav?.extras?.state || {};
   }

  ionViewDidEnter() {
    this.activePlan = this.routerState['activePlan'] || this.activePlan;
    this.activeTeam = this.routerState['activeTeam'] || this.activeTeam;
    this.player = this.routerState['player'] || this.player;
    this.setAttributes();
  }

  setAttributes() {
    document.documentElement.style.setProperty('--tshirtcolor1', this.player.color1);
    document.documentElement.style.setProperty('--tshirtcolor2', this.player.color2);
  }

  onColorSelect(color, index) {
    if (index > 0) {
      this.ls.field.color2 = this.player.color2 = color;
      document.documentElement.style.setProperty('--tshirtcolor2', color);
    } else {
      this.ls.field.color1 = this.player.color1 = color;
      document.documentElement.style.setProperty('--tshirtcolor1', color);
    }
    this.ls.save();
    // this.onChange();
  }

  onAddPlayer() {
    if (this.validation()) {
      if (this.newTeamName.length) {
        this.team.name = this.newTeamName;
        this.gs.planList[this.activePlan].teams.push(this.team);
        this.activeTeam = this.gs.planList[this.activePlan].teams.length - 1;
      }
      this.gs.planList[this.activePlan].teams[this.activeTeam].players.push(this.player);
      this.gs.saveTou(this.gs.planList[this.activePlan]).then(plan => this.gs.planList[this.activePlan] = plan);
      this.gs.save();
      this.viewCtrl.dismiss();
    }
  }

  onEditPlayer() {
    if (this.newTeamName.length) {
      this.team.name = this.newTeamName;
      this.gs.planList[this.activePlan].teams.push(this.team);
      this.activeTeam = this.gs.planList[this.activePlan].teams.length - 1;
    }
    this.gs.planList[this.activePlan].teams[this.activeTeam].players.forEach((player)=>{
      if(player.id === this.player.id){
        player = this.player
        this.gs.savePlayer(player)
      }
    })
    this.gs.saveTou(this.gs.planList[this.activePlan]).then(plan => this.gs.planList[this.activePlan] = plan);
    this.gs.save();
    this.viewCtrl.dismiss();
  }

  validation() {
    if (!this.gs.createPlanIfEmpty(this.newPlanName)) {
      if (this.isPlayerFound()) {
        return false;
      }
    }
    return true;
  }

  isExists(){
    let index = this.gs.planList[this.activePlan].teams[this.activeTeam].players.findIndex(t => t.name == this.player.name)
    if (index > -1) {
      return true;
    }else{
      return false
    }
  }

  isPlayerFound() {
    let index = this.gs.planList[this.activePlan].teams[this.activeTeam].players.findIndex(t => t.name == this.player.name);
    if (index > -1) {
      this.showMessage(this.translate.instant('PLAYER_EXIST_MESSAGE'));
      return true;
    }
    return false;
  }

  onDeletePlayer() {
    if (this.gs.planList[this.activePlan] && this.gs.planList[this.activePlan].teams[this.activeTeam]) {
      this.gs.planList[this.activePlan].teams[this.activeTeam].players = this.gs.planList[this.activePlan].teams[this.activeTeam].players.filter(p => p.name != this.player.name);
      this.gs.removePlayerById(this.player.id);
      this.gs.save();
    }
    this.viewCtrl.dismiss();
  }

  showMessage(message: string) {
    this.toastCtrl.create({
      message: message,
      position: 'top',
      duration: 3000
    }).then(toast=>{
      toast.present()
    });
  }

  onValueChange(key, value) {
    this.ls.field[key] = this.player[key] = value;
    this.ls.saveDisplayConfigs();
  }

  public get style(): typeof TshirtStyle {
    return TshirtStyle;
  }

  get activePlanName(): string {
    return this.gs.planList?.[this.activePlan]?.name || this.newPlanName;
  }

  set activePlanName(value: string) {
    if (this.gs.planList?.[this.activePlan]) {
      this.gs.planList[this.activePlan].name = value;
    } else {
      this.newPlanName = value;
    }
  }
  get activePlanList(): string {
    return this.gs.planList?.[this.activePlan]?.teams[this.activeTeam]?.name;
  }

  set activePlanList(value: string) {
    if(this.gs.planList?.[this.activePlan]){
      this.gs.planList[this.activePlan].teams[this.activeTeam].name = value;
    }else{
      this.newTeamName = value
    }
  }


  styles = [
    this.translate.instant('ONE_COLOR'),
    this.translate.instant('HORIZONTAL_LINES'),
    this.translate.instant('VERTICAL_LINES')
  ];

  types = [
    this.translate.instant('bandedcollar'),
    this.translate.instant('henley'),
    this.translate.instant('hoodie'),
    this.translate.instant('longsleeves'),
    this.translate.instant('nosleeves'),
    this.translate.instant('polo'),
    this.translate.instant('shirt'),
    this.translate.instant('tshirt'),
    this.translate.instant('vneck')
  ]

  player: IPlayer = {
    id: new Date().getTime(),
    name: "",
    memo: "",
    color1: this.ls.field.color1,
    color2: this.ls.field.color2,
    style: this.ls.field.style,
    type: this.ls.field.type,
    cX: window.innerWidth / 2 - 15,
    cY: 150
  };

  team: ITeam = {
    id: new Date().getTime(),
    name: "",
    players: [],
    results: 0,
    ord: 0,
    points: 0
  };
}

